import { render, staticRenderFns } from "./EditReworkSchedule.vue?vue&type=template&id=886ff1d4"
import script from "./EditReworkSchedule.vue?vue&type=script&lang=js"
export * from "./EditReworkSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports